import {
    AMAZON_ORDERS_TYPE,
    ORDERS_RECONCILE_TYPE,
    EMAILS_TYPE,
    WAREHOUSE_INVENTORY_TYPE,
    RECEIVED_SHIPMENTS_TYPE,
    RECEIVED_INVENTORY_TYPE,
    INVENTORY_COST_CHANGE_TYPE,
    SHIPPING_EACH_COST_CHANGE_TYPE,
    EADIN_COGS_TYPE,
    LOW_STOCK_ALERTS_TYPE,
    AMAZON_FBA_LOW_STOCK_ALERTS_TYPE,
    FINANCE_TYPE,
    QUICKBOOKS_TYPE,
    PROFIT_REPORT_ALL,
    PROFIT_AND_LOSS_HISTORY,
    SHIPMENT_COSTS_TYPE,
    PRODUCTS_TYPE,
    SHOPIFY_AMAZON_INVENTORY,
    BEGIN_INVENTORY,
    SHOPIFY_PRODUCTS,
    SHOPIFY_LANDING_COST,
    SHOPIFY_METAFIELDS,
    SHOPIFY_METAFIELDS_UPDATE,
    OTB_ORDERS,
    SHOPIFY_AMAZON_SALES,
    SHOPIFY_REFUNDS,
    META_INSIGHTS_TYPE,
    META_ADS_TYPE,
    AMAZON_SALES_REPORT,
    CASH_FLOW_REPORT_ALL,
    MISSING_INVENTORY_COST,
    BALANCE_SHEET_REPORT_ALL,
    SHIPHERO_TOKEN_TYPE,
    BOM_PACKAGING_TYPE,
    CHECK_PRODUCT_SALE_STATUS_TYPE,
    SOURCE_SKUS_BY_PRODUCT_TYPE,
    AMAZON_MONTH_END_CLOSE_SUMMARY_TYPE,
    INBOUND_SHIPMENTS_TYPE,
    MONTHLY_AP_PO_PAID_TYPE,
    MONTHLY_PO_AP_DUE_TYPE,
    MONTHLY_PO_AP_PROGRESS_TYPE,
    SALES_BY_PRODUCT_TYPE,
    SALES_BY_PRODUCT_BY_DAY_TYPE,
    SALES_REVENUE_TYPE,
    SALES_REVENUE_MONTHLY_TYPE,
    SHOPIFY_PROFIT_SUMMARY_TYPE,
    SHOPIFY_PROFIT_BY_SKU_SUMMARY_TYPE,
    TOTAL_PRODUCT_REVENUE_TYPE,
    KIT_PRODUCTS_TYPE,
    BILL_COM_TYPE,
    BILLCOM_AP_WRITEBACK_TYPE,
    BILLCOM_PO_RECONCILIATION_REPORT_TYPE,
    BILLCOM_AP_WRITEBACK_STATUS_REPORT_TYPE,
    BILLCOM_BANK_CASH_RECON_REPORT_TYPE,
    EADIN_CATALOG_REPORT_TYPE,
    EADIN_INVENTORY_REPORT_TYPE,
    KLAVIYO_TYPE,
    POSTSCRIPT_TYPE,
    GOOGLE_ADS_METRICS_TYPE,
    MICROSOFT_ADS_METRICS_TYPE,
    APPLOVIN_METRICS_TYPE,
    TIKTOK_ADS_METRICS_TYPE,
    SNAPCHAT_ADS_METRICS_TYPE,
    X_ADS_METRICS_TYPE,
    GA4_METRICS_TYPE,
    STRIPE_SYNC_TYPE,
    ALIA_METRICS_TYPE,
    TRYBE_METRICS_TYPE,
    SHOPIFY_TRYBE_SALES_DAILY,
    FATHOM_MEETINGS_TYPE,
    UPS_TRACKING_TYPE,
    INBOUND_TRANSIT_ALERT,
    INBOUND_RECEIVING_PUTAWAY_ALERT,
    CLARITY_INSIGHTS_TYPE,
    RICHPANEL_SYNC_TYPE,
    MOTION_SYNC_TYPE,
    INTELLIGEMS_SYNC_TYPE,
    DAILY_CHANNEL_METRICS_TYPE,
    COMMAND_CENTER_TYPE,
    EFFECTIVE_CAPITAL_PLAID_SYNC_TYPE,
    AMAZON_AD_SPEND_TYPE,
    AMAZON_SETTLEMENT_FX_TYPE,
    QBO_CHANGE_LEDGER_TYPE,
    SHIPHERO_LOCATIONS_TYPE,
    WAREHOUSE_REPLENISHMENT_TYPE,
    WAREHOUSE_CHECKLIST_DAILY_TYPE,
    WAREHOUSE_CHECKLIST_WEEKLY_TYPE,
    WAREHOUSE_CONSOLIDATION_WEEKLY_TYPE,
    WAREHOUSE_PICK_PACK_DAILY_TYPE,
    CUSTOMER_CARE_DAILY_TYPE,
    SHIPHERO_PICK_PACK_TYPE,
    WAREHOUSE_DATA_GAPS_TYPE,
    AMAZON_MISSING_COST_TYPE,
    WAREHOUSE_CAPACITY_SHEET_SYNC_TYPE,
    THIRTEEN_WEEK_CASH_FLOW_REPORT_TYPE,
    CASH_FLOW_BANK_HOLIDAYS_ROLLOVER_TYPE,
} from "../../consts/cronTypes";

export const MANUAL_RUN_TYPES = {
    [FINANCE_TYPE]: "po",
    [KIT_PRODUCTS_TYPE]: "kit-products",
    [QUICKBOOKS_TYPE]: "qb",
    [EMAILS_TYPE]: "emails",
    [RECEIVED_INVENTORY_TYPE]: "received-inventory",
    [RECEIVED_SHIPMENTS_TYPE]: "received-shipments",
    [WAREHOUSE_INVENTORY_TYPE]: "warehouse-inventory",
    [INVENTORY_COST_CHANGE_TYPE]: "inventory-cost-change",
    [SHIPPING_EACH_COST_CHANGE_TYPE]: "shipping-each-cost-change",
    [EADIN_COGS_TYPE]: "eadin-cogs",
    [LOW_STOCK_ALERTS_TYPE]: "low-stock-alerts",
    [AMAZON_FBA_LOW_STOCK_ALERTS_TYPE]: "amazon-fba-low-stock-alerts",
    [BILL_COM_TYPE]: "bill-com",
    [BILLCOM_AP_WRITEBACK_TYPE]: "billcom-ap-writeback",
    [BILLCOM_PO_RECONCILIATION_REPORT_TYPE]: "billcom-po-reconciliation-report",
    [BILLCOM_AP_WRITEBACK_STATUS_REPORT_TYPE]: "billcom-ap-writeback-status-report",
    [BILLCOM_BANK_CASH_RECON_REPORT_TYPE]: "billcom-bank-cash-recon-report",
    [EADIN_CATALOG_REPORT_TYPE]: "eadin-catalog-report",
    [EADIN_INVENTORY_REPORT_TYPE]: "eadin-inventory-report",
    [EFFECTIVE_CAPITAL_PLAID_SYNC_TYPE]: "effective-capital-sync",
    [AMAZON_ORDERS_TYPE]: "amazon-orders",
    [ORDERS_RECONCILE_TYPE]: "orders-reconcile",
    [SHIPMENT_COSTS_TYPE]: "shipment-costs",
    [PROFIT_REPORT_ALL]: "qb-reports",
    [MISSING_INVENTORY_COST]: "missing-inventory-cost",
    [AMAZON_MISSING_COST_TYPE]: "amazon-missing-cost",
    [PRODUCTS_TYPE]: "products",
    [SHOPIFY_AMAZON_INVENTORY]: "shopify-amazon-inventory",
    [BEGIN_INVENTORY]: "begin-inventory",
    [SHOPIFY_REFUNDS]: "shopify-refunds",
    [META_INSIGHTS_TYPE]: "meta-insights",
    [META_ADS_TYPE]: "meta-ads",
    [AMAZON_SALES_REPORT]: "amazon-sales-report",
    [OTB_ORDERS]: "otb-orders",
    [PROFIT_AND_LOSS_HISTORY]: "profit-and-loss-history",
    [SHOPIFY_PRODUCTS]: "shopify-products",
    [SHIPHERO_TOKEN_TYPE]: "shiphero-token",
    [SHOPIFY_LANDING_COST]: "shopify-landing-cost",
    [SHOPIFY_METAFIELDS_UPDATE]: "shopify-metafields-update",
    [SHOPIFY_METAFIELDS]: "shopify-metafields",
    [SHOPIFY_AMAZON_SALES]: "shopify-amazon-orders",
    [CASH_FLOW_REPORT_ALL]: "qb-cash-flow",
    [BALANCE_SHEET_REPORT_ALL]: "qb-balance-sheet",
    [BOM_PACKAGING_TYPE]: "bom-packaging",
    [CHECK_PRODUCT_SALE_STATUS_TYPE]: "check-product-sale-status",
    [SOURCE_SKUS_BY_PRODUCT_TYPE]: "source-skus-by-product",
    [AMAZON_MONTH_END_CLOSE_SUMMARY_TYPE]: "amazon-month-end-close-summary",
    [INBOUND_SHIPMENTS_TYPE]: "inbound-shipments",
    [MONTHLY_AP_PO_PAID_TYPE]: "monthly-ap-po-paid",
    [MONTHLY_PO_AP_DUE_TYPE]: "monthly-po-ap-due",
    [MONTHLY_PO_AP_PROGRESS_TYPE]: "monthly-po-ap-progress",
    [SALES_BY_PRODUCT_TYPE]: "sales-by-product",
    [SALES_BY_PRODUCT_BY_DAY_TYPE]: "sales-by-product-by-day",
    [SALES_REVENUE_TYPE]: "sales-revenue",
    [SALES_REVENUE_MONTHLY_TYPE]: "sales-revenue-monthly",
    [SHOPIFY_PROFIT_SUMMARY_TYPE]: "shopify-profit-summary",
    [SHOPIFY_PROFIT_BY_SKU_SUMMARY_TYPE]: "shopify-profit-by-sku-summary",
    [TOTAL_PRODUCT_REVENUE_TYPE]: "total-product-revenue",
    [KLAVIYO_TYPE]: "klaviyo",
    [POSTSCRIPT_TYPE]: "postscript",
    [GOOGLE_ADS_METRICS_TYPE]: "google-ads-metrics",
    [MICROSOFT_ADS_METRICS_TYPE]: "microsoft-ads-metrics",
    [APPLOVIN_METRICS_TYPE]: "applovin-metrics",
    [TIKTOK_ADS_METRICS_TYPE]: "tiktok-ads-metrics",
    [SNAPCHAT_ADS_METRICS_TYPE]: "snapchat-ads-metrics",
    [X_ADS_METRICS_TYPE]: "x-ads-metrics",
    [GA4_METRICS_TYPE]: "ga4-metrics",
    [STRIPE_SYNC_TYPE]: "stripe-sync",
    [ALIA_METRICS_TYPE]: "alia-metrics",
    [TRYBE_METRICS_TYPE]: "trybe-metrics",
    [SHOPIFY_TRYBE_SALES_DAILY]: "shopify-trybe-sales-daily",
    [FATHOM_MEETINGS_TYPE]: "fathom-meetings",
    [UPS_TRACKING_TYPE]: "ups-tracking",
    [INBOUND_TRANSIT_ALERT]: "inbound-transit-alert",
    [INBOUND_RECEIVING_PUTAWAY_ALERT]: "inbound-receiving-putaway-alert",
    [CLARITY_INSIGHTS_TYPE]: "clarity-insights",
    [RICHPANEL_SYNC_TYPE]: "richpanel-sync",
    [MOTION_SYNC_TYPE]: "motion-sync",
    [INTELLIGEMS_SYNC_TYPE]: "intelligems-sync",
    [DAILY_CHANNEL_METRICS_TYPE]: "daily-channel-metrics",
    [COMMAND_CENTER_TYPE]: "command-center",
    [AMAZON_AD_SPEND_TYPE]: "amazon-ad-spend",
    [AMAZON_SETTLEMENT_FX_TYPE]: "amazon-settlement-fx",
    [QBO_CHANGE_LEDGER_TYPE]: "qbo-change-ledger",
    [SHIPHERO_LOCATIONS_TYPE]: "shiphero-locations",
    [WAREHOUSE_REPLENISHMENT_TYPE]: "warehouse-replenishment",
    [WAREHOUSE_CHECKLIST_DAILY_TYPE]: "warehouse-checklist-daily",
    [WAREHOUSE_CHECKLIST_WEEKLY_TYPE]: "warehouse-checklist-weekly",
    [WAREHOUSE_CONSOLIDATION_WEEKLY_TYPE]: "warehouse-consolidation-weekly",
    [WAREHOUSE_PICK_PACK_DAILY_TYPE]: "warehouse-pick-pack-daily",
    [CUSTOMER_CARE_DAILY_TYPE]: "customer-care-daily",
    [SHIPHERO_PICK_PACK_TYPE]: "shiphero-pick-pack",
    [WAREHOUSE_DATA_GAPS_TYPE]: "warehouse-data-gaps",
    [WAREHOUSE_CAPACITY_SHEET_SYNC_TYPE]: "warehouse-capacity-sheet-sync",
    [THIRTEEN_WEEK_CASH_FLOW_REPORT_TYPE]: "thirteen-week-cash-flow-report",
    [CASH_FLOW_BANK_HOLIDAYS_ROLLOVER_TYPE]: "cash-flow-bank-holidays-rollover",
};

export const CRON_CATEGORIES = ["Sales", "Finance", "Inventory", "Marketing", "Fulfillment", "Customer Care", "Operations"];

const CATEGORY_TYPES = {
    Sales: "AMAZON_ORDERS AMAZON_SALES_REPORT SHOPIFY_AMAZON_SALES SHOPIFY_REFUNDS CHECK_PRODUCT_SALE_STATUS ORDERS_RECONCILE OTB_ORDERS SALES_REVENUE SALES_BY_PRODUCT_BY_DAY SALES_BY_PRODUCT TOTAL_PRODUCT_REVENUE",
    Marketing: "ALIA_METRICS AMAZON_AD_SPEND APPLOVIN_METRICS GA4_METRICS GOOGLE_ADS_METRICS KLAVIYO META_ADS META_INSIGHTS MICROSOFT_ADS_METRICS CLARITY_INSIGHTS MOTION_SYNC POSTSCRIPT SNAPCHAT_ADS_METRICS TIKTOK_ADS_METRICS TRYBE_METRICS SHOPIFY_TRYBE_SALES_DAILY X_ADS_METRICS INTELLIGEMS_SYNC SALES_REVENUE_MONTHLY SHOPIFY_PROFIT_SUMMARY SHOPIFY_PROFIT_BY_SKU_SUMMARY DAILY_CHANNEL_METRICS",
    Finance: "THIRTEEN_WEEK_CASH_FLOW_REPORT CASH_FLOW_BANK_HOLIDAYS_ROLLOVER AMAZON_TRANSACTION_DETAIL AMAZON_SETTLEMENT_FX BALANCE_SHEET_REPORT_ALL BILL_COM BILLCOM_AP_WRITEBACK BILLCOM_AP_WRITEBACK_STATUS_REPORT BILLCOM_BANK_CASH_RECON_REPORT BILLCOM_PO_RECONCILIATION_REPORT CASH_FLOW_REPORT_ALL EFFECTIVE_CAPITAL_PLAID_SYNC PROFIT_REPORT_ALL PROFIT_AND_LOSS_HISTORY FINANCE QBO_CHANGE_LEDGER QUICKBOOKS STRIPE_SYNC AMAZON_MONTH_END_CLOSE_SUMMARY EADIN_COGS MONTHLY_AP_PO_PAID MONTHLY_PO_AP_DUE MONTHLY_PO_AP_PROGRESS RECEIVED_INVENTORY",
    Inventory: "SHIPHERO_INVENTORY_LEDGER BEGIN_INVENTORY KIT_PRODUCTS_TYPE PRODUCTS SHIPHERO_LOCATIONS SHOPIFY_AMAZON_INVENTORY SHOPIFY_LANDING_COST INVENTORY_COST_CHANGE WAREHOUSE_INVENTORY LOW_STOCK_ALERTS AMAZON_FBA_LOW_STOCK_ALERTS MISSING_INVENTORY_COST AMAZON_MISSING_COST EADIN_CATALOG_REPORT WAREHOUSE_CONSOLIDATION_WEEKLY",
    Fulfillment: "SHIPHERO_PICK_PACK WAREHOUSE_PICK_PACK_DAILY INBOUND_TRANSIT_ALERT INBOUND_RECEIVING_PUTAWAY_ALERT SHIPMENT_COSTS UPS_TRACKING WAREHOUSE_CHECKLIST_DAILY WAREHOUSE_REPLENISHMENT WAREHOUSE_CHECKLIST_WEEKLY WAREHOUSE_DATA_GAPS WAREHOUSE_CAPACITY_SHEET_SYNC RECEIVED_SHIPMENTS INBOUND_SHIPMENTS SHIPPING_EACH_COST_CHANGE",
    "Customer Care": "CUSTOMER_CARE_DAILY",
};

const CATEGORY_BY_TYPE = Object.entries(CATEGORY_TYPES).reduce((acc, [category, types]) => {
    types.split(" ").forEach((type) => { acc[type] = category; });
    return acc;
}, {});

export const getCronCategory = (type) => CATEGORY_BY_TYPE[type] || "Operations";

const LOGO_PREFIXES = [
    ["THIRTEEN_WEEK", null],
    ["SHIPHERO", "shiphero"],
    ["AMAZON", "amazon"],
    ["APPLOVIN", "applovin"],
    ["QUICKBOOKS", "quickbooks"],
    ["QBO_", "quickbooks"],
    ["BALANCE_SHEET", "quickbooks"],
    ["CASH_FLOW_REPORT_ALL", "quickbooks"],
    ["PROFIT_REPORT_ALL", "quickbooks"],
    ["PROFIT_AND_LOSS", "quickbooks"],
    ["BILL", "billcom"],
    ["META_", "meta"],
    ["GOOGLE_ADS", "google-ads"],
    ["GA4", "google-analytics"],
    ["KLAVIYO", "klaviyo"],
    ["POSTSCRIPT", "postscript"],
    ["STRIPE", "stripe"],
    ["TIKTOK", "tiktok"],
    ["SNAPCHAT", "snapchat"],
    ["X_ADS", "x"],
    ["MICROSOFT_ADS", "microsoft-ads"],
    ["CLARITY", "microsoft-clarity"],
    ["SHOPIFY", "shopify"],
    ["UPS_", "ups"],
    ["PLAID", "plaid"],
    ["EFFECTIVE_CAPITAL_PLAID", "plaid"],
    ["FATHOM", "fathom"],
    ["ALIA", "alia"],
    ["TRYBE", "trybe"],
    ["RICHPANEL", "richpanel"],
    ["INTELLIGEMS", "intelligems"],
    ["MOTION", "motion"],
];

export const EADIN_LOGO_SRC = "/brand/eadin-mark.png";

export const getCronLogoSrc = (type) => {
    const match = LOGO_PREFIXES.find(([prefix]) => String(type || "").startsWith(prefix));
    return match?.[1] ? `/brand/integrations/${match[1]}.png` : EADIN_LOGO_SRC;
};

const titleCaseType = (type) => String(type || "")
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ")
    .replace(/Shiphero/g, "ShipHero");

export const getCronDisplayName = (cron) => {
    const raw = String(cron?.name || "").trim();
    const comingSoon = /\(coming soon\)/i.test(raw);
    const cleaned = raw.replace(/\s*\(coming soon\)/gi, "").trim();
    const name = !cleaned || /^\.+$/.test(cleaned) ? titleCaseType(cron?.type) : cleaned;
    return { name, comingSoon };
};
